module.exports = __webpack_public_path__ + "static/media/ONG.e7426f2c.svg";